import { render, staticRenderFns } from "./modal-historico-geracao-repasse.vue?vue&type=template&id=21264958&scoped=true"
import script from "./modal-historico-geracao-repasse.ts?vue&type=script&lang=ts&external"
export * from "./modal-historico-geracao-repasse.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-historico-geracao-repasse.scss?vue&type=style&index=0&id=21264958&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21264958",
  null
  
)

export default component.exports